import React, { Fragment, useCallback, useEffect } from 'react'
import { useMutation, useQuery } from '@apollo/client'
import { CONTACTS } from '../../apollo/query'
import { MdCheck, MdClose } from 'react-icons/md'
import { Button, Grid } from '@material-ui/core'
import { CONTACT_MUTATION } from '../../apollo/mutation'
import { clearTypeName } from '../../lib/graph-stuff'
import normalizeString from '../../lib/normalizeString'

export default function CheckContact({contact, onChange}) {
    
     const [mutateCustomer] = useMutation(CONTACT_MUTATION)



    const {data, loading, error, refetch } = useQuery(CONTACTS, {
        variables:{
            item: {
                lookup: {
                    key: "name", 
                    value: contact?.name, 
                    op: "contains"
                }
            }
        }
    })

    const handleAddContact = item => () => {
            mutateCustomer({variables: {
                data: clearTypeName( {...item} )
            }}).then( 
                r => { 
                    alert("CONTACTUL A FOST CREAT");
                    refetch();
                    onChange(r?.data?.contact)
                },
                err => {console.log("err:", err); }
            )
            
        }

        const handleConfirmContact = () => {
            let newElem = data.contacts.find( el => el.name === contact?.name)
             onChange(newElem)
             refetch()
        }

    return (
        <Fragment>

        {contact && (
        <Grid container alignItems='center' justifyContent='space-between'>
             <strong>{contact.name}</strong>
            {loading && "Se verifica..."}
            
  
            
                {!loading 
                && data?.contacts 
                && data.contacts.find( el => normalizeString(el.name) === normalizeString(contact?.name)) 
                    ? <Button variant='contained' color="primary" size="small" onClick={handleConfirmContact} disabled = {contact.id}>CONFIRMA</Button>
                    : <Button variant='contained' color="secondary" size="small" onClick={handleAddContact(contact)}>ADAUGA</Button>
                }
                        

                 


        </Grid>
        )}
        </Fragment>
    )



}
